// import React from 'react'
// import ProductsTable from './DraftPages/ProductsTable';

import MOQPriceAdjuster from "./DraftPages/MOQPriceAdjuster"

// import CompanyCard from "../components/CompanyCard";

function DraftPage() {
  return (
    <div className='container'>
      <MOQPriceAdjuster minPrice={250} maxPrice={350} MOQ={10} />
      {/* <CompanyCard /> */}
      {/* <ProductsTable /> */}
    </div>
  )
}

export default DraftPage